import { useEffect, useState } from "react";
import ApiService from "../../services/ApiServiceClass";


export const useGetMembersByRequestID = (requestID: number) => {

    const fetMembersByRequestID = async () => {
        try {
            const responseData = await ApiService.getMembersByRequestID(requestID);
            return responseData.data;
        } catch(error) {
            throw(error);
        }
    }

    return { fetMembersByRequestID }
}